import { api } from "../../../api/axiosInstance";
import type {
  GetConversationsRequest,
  GetConversationMessagesRequest,
  ReadConversationMessagesRequest,
  ResendConversationMessagesRequest,
  DeleteConversationMessageRequest,
  CreateConversationRequest,
  DeleteConversationMessageFileRequest,
  PresignUrlRequest,
  SerializedConversationPayload,
} from "../ts";

export const conversationsAPI = {
  getUnreadMessagesCount() {
    return api.get("/api/v1/conversations/unread/");
  },
  getConversationsList(requestParams: GetConversationsRequest) {
    return api.get("/api/v1/conversations/", { params: requestParams });
  },
  getConversationMessages(requestParams: GetConversationMessagesRequest) {
    return api.get(
      `/api/v1/conversations/${requestParams.conversationId}/messages/`,
      {
        params: { limit: requestParams.limit, offset: requestParams.offset },
      },
    );
  },
  createPresignUrl(
    conversation_id: string,
    requestData: FormData,
  ) {
    return api.post(
      `/api/v1/conversations/${conversation_id}/file/presign/`,
      requestData,
    );
  },
  getPresignUrl(
    requestParams: PresignUrlRequest,
  ) {
    return api.get(
      `/api/v1/conversations/${requestParams.conversation_id}/file/presign/?file_key=${requestParams.file_key}`
    );
  },
  readConversationMessages(requestData: ReadConversationMessagesRequest) {
    return api.patch(
      `/api/v1/conversations/${requestData.conversation_id}/messages/read/`,
      requestData,
    );
  },
  resendConversationMessages(requestData: ResendConversationMessagesRequest) {
    return api.patch(
      `/api/v1/conversations/${requestData.conversation_id}/messages/resend/`,
      requestData,
    );
  },
  createConversationMessages(conversationId: string, requestData: SerializedConversationPayload) {
    return api.post(
      `/api/v1/conversations/${conversationId}/messages/`,
      requestData,
    );
  },
  deleteConversationMessages(request: DeleteConversationMessageRequest) {
    return api.delete(
      `/api/v1/conversations/${request.conversation_id}/messages/`,
      {
        data: { message_id_list: request.message_ids },
      },
    );
  },
  createConversation(requestData: CreateConversationRequest) {
    return api.post(`/api/v1/conversations/`, requestData);
  },
  getConversation(companionId: string) {
    return api.get(`/api/v1/conversations/${companionId}/`);
  },
  updateConversationMessages(conversationId: string, requestData: SerializedConversationPayload) {
    return api.patch(
      `/api/v1/conversations/${conversationId}/messages/`,
      requestData,
    );
  },
  deleteConversationMessageFile(
    conversationId: string,
    request: DeleteConversationMessageFileRequest,
  ) {
    return api.delete(
      `/api/v1/conversations/${conversationId}/messages/${request.message_id}/files`,
      {
        data: { file_id_list: [request.file_id] },
      },
    );
  },
};
